import type { JSX } from 'react';

import type { FontSize } from 'pkg/config/fonts';
import * as styles from 'pkg/config/styles';

import { cssClasses, cssVarList, type CSSVariables } from 'pkg/css/utils';

import Row from 'components/layout/row';

import * as css from './styles.css';

interface DividerProps {
	text?: string;
	margin?: styles.spacing;
	small?: boolean;
	fontSize?: FontSize;
}

export default function Divider({
	text,
	margin,
	small,
	fontSize,
}: DividerProps): JSX.Element {
	const vars: CSSVariables = {
		margin: margin,
		'font-size': fontSize,
	};

	if (margin) {
		vars.margin = margin;
	}

	if (fontSize) {
		vars['font-size'] = fontSize;
	}

	return (
		<Row
			spacing={text ? styles.spacing._2 : styles.spacing._0}
			align="center"
			columns={text ? '1fr auto 1fr' : '1fr'}
			className={cssClasses(css.wrapper, small ? css.small : '')}
			style={cssVarList(vars)}>
			{text && <div className={css.text}>{text}</div>}
		</Row>
	);
}
